import React, { useEffect, useState } from 'react';
import { Modal, Form, Input, Select, notification, message } from 'antd';
import { useDispatch } from 'react-redux';
import { assignVessels, getUserDetails, postUserDetails } from '../../../features/UserManagement/UserManagementSlice';

const { Option } = Select;

const AssignModal = ({ visible, onOk, onCancel, recordToAssign, usernameAssign }) => {
    const dispatch = useDispatch();
    const [form] = Form.useForm();
    const [submitting, setSubmitting] = useState(false);
    const vesselList = ["Admin Pooling Agent", "Pooling Agent"];


    const onFinish = async (values) => {
        if (submitting) return;

        try {
            setSubmitting(true);
            console.log(values)
            const payload = {
                user_name: usernameAssign,
                id: recordToAssign,
                values
            }
            const response = await dispatch(assignVessels(values));
            console.log(response)
            if (response.error) {
                throw new Error(response.error.message);
            } else {
                dispatch(getUserDetails())
                notification.success({
                    message: 'Vessel Assigned Successfully',
                    description: `User ${values.vessel_name} has been assigned.`,
                });
            }
            form.resetFields();
            setSubmitting(false);
            await onOk();
        } catch (error) {
            notification.error({
                message: 'Error assigning vessel! ',
                description: `There was an error assigning vessel: ${error.message}`,
            });
            setSubmitting(false);
        }
    };

    console.log(usernameAssign)

    return (

        <Modal
            title="Assign Vessel"
            visible={visible}
            onCancel={onCancel}
            okText="Submit"
            confirmLoading={submitting}
            onOk={() => form.submit()}
        >
            <Form
                form={form}
                layout="vertical"
                name="add_user_form"
                className='add-user-modal-content'
                onFinish={onFinish}
                initialValues={{
                    record_name: usernameAssign,
                }}
            >
                <Form.Item
                    className='assignModal-content'
                    label="User Detail"
                    name="record_name"
                    value={usernameAssign}
                >
                    <Input disabled />
                </Form.Item>
                <Form.Item
                    label="Vessel"
                    name="vessel_name"
                    rules={[{ required: true, message: 'Please select a user type!' }]}
                >
                    <Select
                        placeholder="Select a user type"
                        allowClear
                    >
                        {vesselList.map((category) => {
                            return (
                                <Option key={category} value={category}>
                                    {category}
                                </Option>
                            );
                        })}
                    </Select>
                </Form.Item>
            </Form>
        </Modal>

    );
};

export default AssignModal;
